<div>
  <a href="https://wannaflix.com/"><h1>Unblock Streaming Regions With WannaFlix</h1></a>
</div>

<style>
  h1 {
    color: #ff7b00;
    font-size: 1em;
    font-weight: 300;
    padding: 1.5rem;
  }
  div {
    text-align: center;
    background-color: black;
    margin-top: -1.5em;
    margin-left: -1rem;
    margin-right: -1rem;
  }
</style>
